import { localeLoaderMiddleware } from '@opengov/locale/loader';

// To keep webpack's dynamic module resolution from dramatically increasing build time,
// each module that provides locale data defines it's own loader
export const localeLoader = async (namespace: string, locale: string) =>
  import(/* webpackChunkName: "[request]" */ `./${namespace}.${locale}.locale.json`).then((result: any) => result);

export const localeMiddleware = localeLoaderMiddleware('appCore', localeLoader);
